import { gtmSendEvent } from "@wojo/analytics";
import { Button, Text } from "@wojo/ui";
import { useState } from "react";
import style from "./TourHeroSummaryInfo.module.scss";
import { TourHeroSummaryInfoModal } from "./TourHeroSummaryInfoModal";

type TourHeroDetailProps = {
    label?: string | null;
    title?: string | null;
    description?: string | null;
};

export const TourHeroDetail: React.FC<TourHeroDetailProps> = ({
    label,
    title,
    description,
}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    if (!label || !title || !description) {
        return null;
    }

    return (
        <Text tag="dl" className={style["summary-info-detail-wrapper"]}>
            <Text tag="dt">{label}</Text>
            <Text tag="dd" className={style["summary-info-detail"]}>
                <Button
                    variant="quiet"
                    onClick={() => {
                        gtmSendEvent({
                            event: "track",
                            ga4Tracking: {
                                ga4_action: "OPENED",
                                ga4_object: "MODAL",
                                modalId: `Tour ${label}`,
                            },
                        });
                        setIsModalOpen(true);
                    }}
                >
                    {title}
                </Button>
            </Text>
            <TourHeroSummaryInfoModal
                onCloseRequested={() => {
                    gtmSendEvent({
                        event: "track",
                        ga4Tracking: {
                            ga4_action: "CLOSED",
                            ga4_object: "MODAL",
                            modalId: `Tour ${label}`,
                        },
                    });
                    setIsModalOpen(false);
                }}
                isOpen={isModalOpen}
                heading={title}
                description={description}
                accessibleTitle={label}
            />
        </Text>
    );
};
